import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BottomSheetConfig, MatDialogTransportListData } from 'src/app/interfaces/mat.interface';
import { Transport } from 'src/app/pages/custom-route/interfaces/custom-route.interface';
import { TimelineStatus } from 'src/app/pages/custom-route/shared/planner/components/route-timeline/interfaces';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { AllTransportListComponent } from '../../../../../all-transport-list/all-transport-list.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-transport-list-card-icon-list-overflow',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './transport-list-card-icon-list-overflow.component.html',
  styleUrls: ['./transport-list-card-icon-list-overflow.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TransportListCardIconListOverflowComponent {
  public transportList = input.required<Transport[]>();
  public pointTitle = input.required<string>();
  public previousPointTitle = input.required<string>();
  public status = input.required<TimelineStatus>();
  
  private _breakpointsService = inject(BreakpointsService);
  private _bottomSheet = inject(MatBottomSheet);
  
  private _isMobile = this._breakpointsService.isMobile;
  
  public handleClickOverflowTransportList(): void {
    if (this._isMobile()) {
      this.openBottomSheetTransportListMobile();
    } else {
      this.openBottomSheetTransportListDesktop();
    }
  }
  
public openBottomSheetTransportListMobile(): void {
    const bottomSheetConfig: BottomSheetConfig<AllTransportListComponent, MatDialogTransportListData> = {
      component: AllTransportListComponent,
      data: {
        transportList: this.transportList(),
        pointTitle: this.pointTitle(),
        previousPointTitle: this.previousPointTitle(),
      },
      panelClass: 'all-transport-list-bottom-sheet--mobile',
    }
    this._bottomSheet.open(AllTransportListComponent, bottomSheetConfig);
  }
    
  public openBottomSheetTransportListDesktop(): void {
    const bottomSheetConfig: BottomSheetConfig<AllTransportListComponent, MatDialogTransportListData> = {
      component: AllTransportListComponent,
      data: {
        transportList: this.transportList(),
        pointTitle: this.pointTitle(),
        previousPointTitle: this.previousPointTitle(),
      },
      panelClass: 'all-transport-list-bottom-sheet--desktop',
    }
    this._bottomSheet.open(AllTransportListComponent, bottomSheetConfig);
  }
}
